// extracted by mini-css-extract-plugin
export var gif = "_ct-0";